import React, { useState } from 'react';
import { ShoppingCart, Filter } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { storeItems, locations } from '../mockData';
import { toast } from 'sonner';

const Store = () => {
  const [selectedLocation, setSelectedLocation] = useState('all');

  const filteredItems = selectedLocation === 'all' 
    ? storeItems 
    : storeItems.filter(item => item.locationId === parseInt(selectedLocation));

  const handleAddToCart = (item) => {
    toast.success(`${item.name} added to cart!`);
  };

  return (
    <div className="min-h-screen bg-black">
      {/* Header */}
      <div className="bg-gradient-to-r from-yellow-600 to-yellow-400 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold text-black mb-4">Sports Store</h1>
          <p className="text-xl text-gray-900">Buy or rent quality sports equipment</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Filters */}
        <div className="mb-8">
          <div className="flex flex-wrap gap-3">
            <button
              onClick={() => setSelectedLocation('all')}
              className={`px-6 py-2 rounded-full font-semibold transition-all ${
                selectedLocation === 'all'
                  ? 'bg-yellow-400 text-black'
                  : 'bg-gray-900 text-white border border-yellow-500/20 hover:border-yellow-400'
              }`}
            >
              All Items
            </button>
            {locations.map((location) => (
              <button
                key={location.id}
                onClick={() => setSelectedLocation(location.id.toString())}
                className={`px-6 py-2 rounded-full font-semibold transition-all ${
                  selectedLocation === location.id.toString()
                    ? 'bg-yellow-400 text-black'
                    : 'bg-gray-900 text-white border border-yellow-500/20 hover:border-yellow-400'
                }`}
              >
                {location.name}
              </button>
            ))}
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {filteredItems.map((item) => (
            <Card key={item.id} className="bg-gray-900 border-yellow-500/20 hover:border-yellow-400 transition-all overflow-hidden group">
              <CardContent className="p-0">
                <div className="relative h-48 overflow-hidden bg-gray-800">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  {item.available && (
                    <Badge className="absolute top-3 right-3 bg-green-600">
                      In Stock
                    </Badge>
                  )}
                </div>
                
                <div className="p-4">
                  <Badge variant="outline" className="mb-2 text-xs border-yellow-400 text-yellow-400">
                    {item.category}
                  </Badge>
                  <h3 className="font-bold text-white mb-3">{item.name}</h3>
                  
                  <div className="space-y-2 mb-4">
                    <div className="flex justify-between items-center">
                      <span className="text-gray-400 text-sm">Buy:</span>
                      <span className="text-xl font-bold text-yellow-400">₹{item.price}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-400 text-sm">Rent:</span>
                      <span className="text-lg font-semibold text-green-400">₹{item.rental}/day</span>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-2">
                    <Button
                      size="sm"
                      variant="outline"
                      className="border-yellow-400 text-yellow-400 hover:bg-yellow-400 hover:text-black"
                      onClick={() => handleAddToCart(item)}
                    >
                      Rent
                    </Button>
                    <Button
                      size="sm"
                      className="bg-yellow-400 hover:bg-yellow-500 text-black font-semibold"
                      onClick={() => handleAddToCart(item)}
                    >
                      Buy
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {filteredItems.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-400 text-lg">No items found for this location.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Store;